import { render, staticRenderFns } from "./FavoriteToggle.vue?vue&type=template&id=39e371d8&"
import script from "./FavoriteToggle.vue?vue&type=script&lang=js&"
export * from "./FavoriteToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports